import { render, staticRenderFns } from "./DiverseEditLedgers.vue?vue&type=template&id=a0462f8a&scoped=true"
import script from "./DiverseEditLedgers.vue?vue&type=script&lang=ts"
export * from "./DiverseEditLedgers.vue?vue&type=script&lang=ts"
import style0 from "./DiverseEditLedgers.vue?vue&type=style&index=0&id=a0462f8a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0462f8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0462f8a')) {
      api.createRecord('a0462f8a', component.options)
    } else {
      api.reload('a0462f8a', component.options)
    }
    module.hot.accept("./DiverseEditLedgers.vue?vue&type=template&id=a0462f8a&scoped=true", function () {
      api.rerender('a0462f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/DiverseEditLedgers.vue"
export default component.exports